/* eslint-disable @typescript-eslint/no-empty-object-type */
import TrafficLightComponent from "@/Components/TrafficLightComponent";
import { WizardStep } from "@/Components/wizard/wizardStep";

export function getBasicPageTourSteps(): WizardStep[] {
    const steps: WizardStep[] = [
        {
            stepId: 1,
            stepName: "Refresh Data",
            stepDescription: "Reload the dashboard data without having to refresh the page.",
            isCompleted: false,
            stepComponentId: "refreshDashboardButton",
            displaySide: "right" as "right" | "left" | "top" | "bottom",
            sendClick: true,
        },
        {
            stepId: 2,
            stepName: "Select Projects",
            stepDescription: "Use the selected projects filter to choose which projects to display data for. This filter will be saved in your preferences.",
            isCompleted: false,
            stepComponentId: "selectProjectsButton",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 3,
            stepName: "View Button",
            stepDescription: "Click this button to select which dashboard elements to display on the dashboard. This will be saved in your preferences.",
            isCompleted: false,
            stepComponentId: "viewButton",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 4,
            stepName: "Radial Chart",
            stepDescription: "The radial chart gives you a quick overview of the overall progress of all your selected projects.",
            isCompleted: false,
            stepComponentId: "radialChartCard",
            displaySide: "right" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 5,
            stepName: "Overview Table",
            stepDescription: "The overview table displays Risks, Issues and Support Requests from all your selected projects, which have been flagged as 'display on dashboard'",
            isCompleted: false,
            stepComponentId: "overviewCard",
            displaySide: "right" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 6,
            stepName: "Overview Row",
            stepDescription: "Clicking on a row in the overview table will take you to the entry in the relevant table (Risks, Issues or Support Requests) where you can view more details. It will also switch to the project associated with that entry. When the page loads the table will be prefilterede to display the entry in question.",
            isCompleted: false,
            stepComponentId: "overviewCardRow",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "right" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 7,
            stepName: "Overall Health",
            stepDescription: "The overall health card displays the overall health of your selected projects based on the traffic light RAG status of each project.",
            isCompleted: false,
            stepComponentId: "overallHealthCard",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 8,
            stepName: "Notifications",
            stepDescription: "When you have new notifications, such as when you are assigned a new Risk or Issue, the bell will 'ring' and display as orange. If you look at the notifications (by clicking the bell) they will be marked as seen and the bell will stop ringing, but will remain orange until the notifications are marked as acknowledged.",
            isCompleted: false,
            stepComponentId: "notificationBell",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 9,
            stepName: "Week Indicator",
            stepDescription: "The week indicator shows the current week and total weeks for all your selected projects.",
            isCompleted: false,
            stepComponentId: "weekIndicator",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 10,
            stepName: "Overall Health",
            stepDescription: getOverallHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getOverallHealthMoreInfo(),
            stepComponentId: "overallHealth",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 11,
            stepName: "Scope Health",
            stepDescription: getScopeHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getScopeHealthMoreInfo(),
            stepComponentId: "scopeHealth",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 12,
            stepName: "Schedule Health",
            stepDescription: getScheduleHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getScheduleHealthMoreInfo(),
            stepComponentId: "scheduleHealth",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 13,
            stepName: "Resource Health",
            stepDescription: getResourceHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getResourceHealthMoreInfo(),
            stepComponentId: "resourcesHealth",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 14,
            stepName: "Financial Health",
            stepDescription: getFinancialHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getFinancialHealthMoreInfo(),
            stepComponentId: "financialHealth",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 15,
            stepName: "Other Health",
            stepDescription: getOtherHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getOtherHealthMoreInfo(),
            stepComponentId: "otherHealth",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 16,
            stepName: "Project Progress Chart",
            stepDescription: "This chart shows the progress of each project.",
            isCompleted: false,
            stepComponentId: "workstreamProgressChartCard",
            displaySide: "right" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 17,
            stepName: "Project Progress Project Name",
            stepDescription: "Clicking on a project name in the project progress chart will take you to the status report for that project.",
            isCompleted: false,
            useClassSelector: true,
            classSelectorNumber: 1,
            stepComponentId: "projectProgressName",
            displaySide: "right" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 18,
            stepName: "Project Progress Row",
            stepDescription: "Clicking on a row in the project progress chart will take you to the Plan page for that project, if the project schedule health isn't green, the plan page will be pre-filtered to show you the tasks which are causing the status.",
            isCompleted: false,
            useClassSelector: true,
            classSelectorNumber: 1,
            stepComponentId: "projectProgressRow",
            displaySide: "right" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 19,
            stepName: "Project Health Table",
            stepDescription: "The project health table displays the health status of each of your selected projects along with the current stage.",
            isCompleted: false,
            stepComponentId: "workstreamHealthCard",
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 20,
            stepName: "Project Life Cycle Stage",
            stepDescription: "This is the current life cycle stage of the project. Clicking on this will take you to the status report for that project, where you can see more details about the current stage and the overall project status.",
            isCompleted: false,
            stepComponentId: "projectLifecycleStage",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 21,
            stepName: "Overall Health",
            stepDescription: getProjectOverallHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getProjectOverallHealthMoreInfo(),
            stepComponentId: "projectOverallHealth",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 22,
            stepName: "Scope Health",
            stepDescription: getProjectScopeHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getProjectScopeHealthMoreInfo(),
            stepComponentId: "projectScopeHealth",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 23,
            stepName: "Schedule Health",
            stepDescription: getProjectScheduleHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getProjectScheduleHealthMoreInfo(),
            stepComponentId: "projectScheduleHealth",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 24,
            stepName: "Resource Health",
            stepDescription: getProjectResourceHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getProjectResourceHealthMoreInfo(),
            stepComponentId: "projectResourcesHealth",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 25,
            stepName: "Financial Health",
            stepDescription: getProjectFinancialHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getProjectFinancialHealthMoreInfo(),
            stepComponentId: "projectFinancialHealth",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        },
        {
            stepId: 26,
            stepName: "Other Health",
            stepDescription: getProjectOtherHealthBasicInfo(),
            isCompleted: false,
            moreInfo: getProjectOtherHealthMoreInfo(),
            stepComponentId: "projectOtherHealth",
            useClassSelector: true,
            classSelectorNumber: 1,
            displaySide: "left" as "right" | "left" | "top" | "bottom",
        }];
    return steps;
}

export function getBasicTourSteps(): WizardStep[] {
    return getBasicPageTourSteps();
}

function getOverallHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the overall health of all the selected projects.
        </div>
    );
}

function getOverallHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">If all selected projects are healthy the overall health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If any selected projects have an amber light in any category the overall health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If any selected projects have a red light in any category the overall health will be red</div></div>
        </div>
    );
}

function getScopeHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the scope of all selected projects based on current change requests. 
            Clicking on this light will filter selected projects based on their scope health, to display the cause of this status.
        </div>
    );
}

function getScopeHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">If no open change requests the scope health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are open change requests the scope health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If the change requests are high impact the scope health will be red</div></div>
        </div>
    );
}

function getScheduleHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the selected projects schedules based on current tasks that are overdue.
            Clicking on this light will filter selected projects based on their schedule health, to display the cause of this status.
        </div>
    );
}

function getScheduleHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No overdue tasks means the schedule health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are overdue tasks the schedule health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are overdue tasks which have dependents or have exceeded the work package end date, the schedule health will be red</div></div>
        </div>
    );
}

function getResourceHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the resources of all selected projects based on current resource requests.
            Clicking on this light will filter selected projects based on their resource health, to display the cause of this status.
        </div>
    );
}

function getResourceHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No Resource Support Requests means the resource health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are Resource Support Requests of medium impact the resource health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are Resource Support Requests of high impact the resource health will be red</div></div>
        </div>
    );
}

function getFinancialHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the finances of all selected projects based on finance support requests.
            Clicking on this light will filter selected projects based on their financial health, to display the cause of this status.
        </div>
    );
}

function getFinancialHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No Financial Support Requests means the financial health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are Financial Support Requests of medium impact the financial health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are Financial Support Requests of high impact the financial health will be red</div></div>
        </div>
    );
}

function getOtherHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the other factors of all selected projects not covered by scope, schedule, resource, or financial health.
            Clicking on this light will filter selected projects based on their other health, to display the cause of this status.
        </div>
    );
}

function getOtherHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No Other Support Requests means the other health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are Other Support Requests of medium impact the other health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are Other Support Requests of high impact the other health will be red</div></div>
        </div>
    );
}

function getProjectOverallHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the overall health of all the project. Clicking on the overall health light will take you to the project status report where you can see more details about the project health and the factors contributing to it.
        </div>
    );
}

function getProjectOverallHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">If the project is healthy the overall health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If the project has an amber light in any category the overall health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If the project has a red light in any category the overall health will be red</div></div>
        </div>
    );
}

function getProjectScopeHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the project scope based on current change requests. 
            If the light is not green, you can click on it to be taken to the Project Change Requests page to see more details.
        </div>
    );
}

function getProjectScopeHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">If no open change requests the scope health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are open change requests the scope health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If the change requests are high impact the scope health will be red</div></div>
        </div>
    );
}

function getProjectScheduleHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the project schedule based on current tasks that are overdue.
            If the light is not green, you can click on it to be taken to the Project Plan page to see more details.
        </div>
    );
}

function getProjectScheduleHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No overdue tasks means the schedule health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are overdue tasks the schedule health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are overdue tasks which have dependents or have exceeded the work package end date, the schedule health will be red</div></div>
        </div>
    );
}

function getProjectResourceHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the project resources based on current resource requests.
            If the light is not green, you can click on it to be taken to the Support Requests page to see more details.
        </div>
    );
}

function getProjectResourceHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No Resource Support Requests means the resource health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are Resource Support Requests of medium impact the resource health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are Resource Support Requests of high impact the resource health will be red</div></div>
        </div>
    );
}

function getProjectFinancialHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the project finances based on current budget status.
            If the light is not green, you can click on it to be taken to the Support Requests page to see more details.
        </div>
    );
}

function getProjectFinancialHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No Financial Support Requests means the financial health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are Financial Support Requests of medium impact the financial health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are Financial Support Requests of high impact the financial health will be red</div></div>
        </div>
    );
}

function getProjectOtherHealthBasicInfo(): JSX.Element {
    return (
        <div className="w-[300px]">
            This traffic light indicates the health of the project based on other factors not covered by scope, schedule, resource, or financial health.
            If the light is not green, you can click on it to be taken to the Support Requests page to see more details.
        </div>
    );
}

function getProjectOtherHealthMoreInfo(): JSX.Element {
    return (
        <div className="flex flex-col w-[300px] p-2">
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={4} Size={5} Animate={false} /></div><div className="">No Other Support Requests means the other health is green</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={2} Size={5} Animate={false} /></div><div className="my-4">If there are Other Support Requests of medium impact the other health will be amber</div></div>
                <div className="flex flex-row"><div className="my-auto pr-4"><TrafficLightComponent TrafficLightColour={1} Size={5} Animate={false} /></div><div className="">If there are Other Support Requests of high impact the other health will be red</div></div>
        </div>
    );
}